package org.example.zone360.pages.players_Details.playerRecentAssessment

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.existingAssessment
import org.example.zone360.utils.getClubCoachesList
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.InputField
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.SearchBar
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.ExistingAssessmentPayload
import org.example.zone360.models.GetClubCoachesListData
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.models.UserData
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement
import org.example.zone360.utils.requestAssessment
import org.example.zone360.utils.updateOrg

@Composable
fun RequestAssessment(
    onDialogDismiss: (Long) -> Unit,
    breakpoint: Breakpoint,
    modalNumber: Long,
    userId: String,
    toastMessageCall: (String) -> Unit,
    getPlayerInfo: GetSinglePlayerData,
    setPlayerInfo: (GetSinglePlayerData) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var searchText by remember { mutableStateOf("") }
    var errorMessage by remember { mutableStateOf("") }
    var coach by remember { mutableStateOf<List<GetClubCoachesListData>>(emptyList()) }
    var filteredCoach by remember { mutableStateOf<List<GetClubCoachesListData>>(emptyList()) }
    var isLoading by remember { mutableStateOf(false) }
    var isJoinLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }
    var assessmentSenderIds by remember { mutableStateOf<Set<String>>(emptySet()) }

    LaunchedEffect(Unit) {
        try {
            val payload = ExistingAssessmentPayload(
                userId = getPlayerInfo.uid,
                organization = AppGlobal.userData.organization,
                requestedBy = "player",
                seasonID = AppGlobal.selectedSeasonId

            )

            val response = existingAssessment(payload)

            // Collect sender IDs
            assessmentSenderIds = response.data
                .map { it.receiverId }
                .toSet()

        } catch (e: Exception) {
            debugPrintln("Existing assessment error: ${e.message}")
        }
    }

    LaunchedEffect(Unit) {
        val response = getClubCoachesList(
            organization = AppGlobal.userData.organization
        )
        coach = response.data
        filteredCoach = coach
    }
    val filteredData = remember(searchText, filteredCoach) {
        if (searchText.isEmpty()) filteredCoach
        else filteredCoach.filter { coach ->
            val coachName = "${coach.firstName} ${coach.lastName}"
            coachName.contains(searchText, ignoreCase = true)
        }
    }

    Box(
        modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 300.px else 350.px)
            .height(600.px)
            .position(Position.Fixed).zIndex(9)
            .top(50.percent).left(50.percent)
            .transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier.padding(topBottom = 24.px).width(100.percent)
                .height(100.percent)
                .margin(top = 10.px).backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                ).borderRadius(4.px),
//                .overflow(Overflow.Auto),
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)
                        .padding(leftRight = 17.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    FieldTitleTextNormalSimple(
                        "Request Assessment",
                        fontSize = 20.px,
                        fontWeight = 600,
                        onClick = {})

                    FaXmark(
                        modifier = Modifier.color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer).onClick { onDialogDismiss(modalNumber) },
                        size = IconSize.LG
                    )

                }

                if (AppGlobal.userData.organization == "independent") {
                    FieldTitleTextNormalSimple(marginLeft = 12.px,
                        marginRight = 12.px,
                        marginBottom = 10.px,
                        text = "These coaches are independent, you can join a club by entering club id. \n After success you'll be asked to login again!",
                        fontSize = 13.px,
                        onClick = {})

                    Row(
                        Modifier.fillMaxWidth().padding(leftRight = 8.px).margin(bottom = 1.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {

                        InputField(
                            width = 270.px,
                            placeHolder = "Enter club id",
                            inputType = InputType.Text,
                            errorText = "",
                            id = Res.Id.clubID,
                            isError = false,
                            marginBottom = 0.px
                        )
                        Box(Modifier.width(7.px)) { }
                        CommonButton(text = "Join", isLoading = isJoinLoading, onCLick = {
                            val clubID =
                                (document.getElementById(Res.Id.clubID) as HTMLInputElement).value
                            if (clubID.isEmpty()) {
                                errorMessage = "Enter Club ID"
                            } else {
                                errorMessage = ""
                                isJoinLoading = true
                                //
                                scope.launch {

                                    val res = updateOrg(
                                        organization = clubID,
                                        oldOrganization = AppGlobal.userData.organization,
                                        uid = AppGlobal.userData.uid
                                    )

                                    isJoinLoading = false

                                    if (res.error == "true") {
                                        errorMessage = res.data!!
                                    } else {
                                        toastMessageCall(res.data!!)
                                        showToast(ToastID.SUCCESS)
                                        AppGlobal.userData = res.userData ?: UserData()
                                        setPlayerInfo(getPlayerInfo.copy(organization = res.userData!!.organization))

                                    }
                                }

                            }


                        }, width = 70.px, height = 45.px)

                    }
                    Box(
                        modifier = Modifier.margin(top = 0.px).padding(leftRight = 10.px)
                            .fillMaxWidth()
                            .align(Alignment.CenterHorizontally),
                        contentAlignment = Alignment.CenterStart
                    ) {
                        FieldTitleTextNormalSimple(
                            text = errorMessage,
                            fontSize = 12.px,
                            color = sitePalette.textErrorColor.rgb, onClick = {}
                        )
                    }
                }

                Row(
                    modifier = Modifier.fillMaxWidth().padding(leftRight = 8.px)
                        .margin(top = 8.px)
                ) {
                    SearchBar(
                        placeholder = "Search Coach",
                        id = "session_Searchbar",
                        breakpoint = Breakpoint.LG,
                        onEnterClick = {},
                        onChange = { newSearchText ->
                            searchText = newSearchText
                        },
                        onClick = {},
                        width = 100.percent,
                        showClearButton = false,
                        height = 48.px,
                        borderColor = Colors.Transparent
                    )
                }
                Column(
                    modifier = Modifier.fillMaxWidth().maxHeight(530.px)
                        .overflow(if (isLoading) Overflow.Hidden else Overflow.Auto)
                ) {
                    Box(modifier = Modifier.fillMaxSize()) {
                        if (isLoading) {
                            Box(
                                modifier = Modifier.fillMaxSize().position(Position.Absolute),
                                contentAlignment = Alignment.Center
                            ) {
                                ProgressIndicator()
                            }
                        }
                        Column(Modifier.padding(leftRight = 20.px)) {
                            filteredData.forEach { coach ->
                                val hasExistingAssessment = assessmentSenderIds.contains(coach.id)
                                CustomSpacer(height = 10.px)
                                Column(modifier = Modifier.margin(topBottom = 6.px)
                                    .cursor(if (isLoading) Cursor.Default else Cursor.Pointer)
                                    .onClick {
                                        if (!isLoading) {
                                            scope.launch {
                                                isLoading = true
                                                val request = requestAssessment(
                                                    coachID = coach.uid,
                                                    coachName = coach.firstName,
                                                    coachEmail = coach.email,
                                                    playerName = getPlayerInfo.firstName + " " + getPlayerInfo.lastName,
                                                    playerEmail = getPlayerInfo.email,
                                                    organization = AppGlobal.userData.organization,
                                                    playerID = if (AppGlobal.userData.role == "player") AppGlobal.userData.uid else userId

                                                )
                                                if (request.response != "") {
                                                    isLoading = false
                                                    toastMessageCall(request.response)
                                                    showToast("toastSuccess")
                                                    onDialogDismiss(modalNumber)
                                                } else {
                                                    isLoading = false
                                                    toastMessageCall(request.error)
                                                    showToast("toastError")
                                                }
                                            }
                                        }

                                    }) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth(),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        if (coach.imageUrl.isNotEmpty()) {
                                            Image(
                                                src = "${Res.Images.base_Image_Url}${coach.imageUrl}",
                                                modifier = Modifier.size(30.px)
                                                    .margin(right = 5.px)
                                                    .borderRadius(100.px)
                                                    .textAlign(TextAlign.Start)
                                            )
                                            
                                        } else {
                                            Image(
                                                src = Res.Images.userIcon,
                                                modifier = Modifier.size(30.px)
                                                    .margin(right = 7.px)
                                                    .borderRadius(100.px)
                                            )
                                        }
                                        Column(modifier = Modifier.weight(1f)) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth(),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                FieldTitleTextNormalSimple(
                                                    "${coach.firstName} ${coach.lastName}",
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 14.px,
                                                    fontWeight = 500,
                                                    isClickable = !isLoading
                                                )
                                                if (hasExistingAssessment){
                                                    Image(
                                                        src = Res.Images.document_black,
                                                        modifier = Modifier.size(16.px)
                                                            .margin(left = 8.px)
                                                    )
                                                }
                                                FieldTitleTextNormalSimple(
                                                    coach.job,
                                                    fontFamily = Constants.IBM_FONT,
                                                    fontSize = 11.px,
                                                    color = Colors.Gray,
                                                    isClickable = !isLoading,
                                                    marginLeft = 10.px
                                                )

                                            }
                                            FieldTitleTextNormalSimple(
                                                coach.email,
                                                fontFamily = Constants.IBM_FONT,
                                                fontSize = 12.px,
                                                color = Colors.Gray,
                                                isClickable = !isLoading,
                                                width = 100.percent
                                            )
                                        }
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }
    }
}
